module.exports = __webpack_public_path__ + "static/media/app-promo-nl.ed5b37d6.png";